import {FC, useEffect, useMemo, useState} from 'react';
import {Tabs, DatePicker, Row, Col, Button, notification, Spin, Skeleton, Select, Divider, Form, Input, Checkbox} from 'antd';
import moment from 'moment';
import apis from '../apis/apis';
import {IKey, IKeyMethods} from '../apis/diaries/diaries';
import useSWR from 'swr';
import {Components, newDiary} from './components/components';
import {DeleteOutlined, PlusOutlined} from '@ant-design/icons';
import CheckableTag from 'antd/lib/tag/CheckableTag';


export const DiariesManager: FC<{
  activeTab: string,
  onTabChange: (_: string) => void,
}> = ({activeTab, onTabChange}) => {
  return <Row>
    <Col span={20} offset={2}>
      <Tabs activeKey={activeTab} onChange={onTabChange} >
        <Tabs.TabPane tab="搜索" key="search">
          <Search />
        </Tabs.TabPane>
        <Tabs.TabPane tab="创建" key="create">
          <Create />
        </Tabs.TabPane>
        <Tabs.TabPane tab="统计" key="statistic">
          TODO IMPLEMENT
        </Tabs.TabPane>
      </Tabs>
    </Col>
  </Row>;
};


const keyFromMoment = (m: moment.Moment): IKey => {
  return {
    Year: m.year(),
    Month: m.month() + 1,
    Day: m.date(),
  };
};

const Create: FC = () => {
  const swrDiaries = useSWR('/diaries', apis.diaries.listDiaies);
  const keys = useMemo(() => swrDiaries.data ? new Set(swrDiaries.data.map((d) => IKeyMethods.asNumber(d.Key))) : new Set(), [swrDiaries]);
  const alreadyExistKey = (k: IKey) => keys.has(IKeyMethods.asNumber(k));

  const [dateFrom, setDateFrom] = useState<moment.Moment>();
  const [dateTo, setDateTo] = useState<moment.Moment>();

  const todayKey = keyFromMoment(moment());


  const disabledDate = (current: IKey): boolean => {
    if (IKeyMethods.gt(current, todayKey)) {
      return true;
    }
    if (alreadyExistKey(current)) {
      return true;
    }
    return false;
  };


  const disabledDateFrom = (current: moment.Moment): boolean => {
    if (dateTo && current > dateTo) {
      return true; // should less than dateTo, if dateTo is set
    }
    return disabledDate(keyFromMoment(current));
  };

  const disabledDateTo = (current: moment.Moment): boolean => {
    if (dateFrom && current < dateFrom) {
      return true; // should greater than dateFrom, if dateFrom is set
    }
    return disabledDate(keyFromMoment(current));
  };


  const [onCreating, setOnCreateing] = useState(false);

  const validate = (): boolean => {
    if (!dateFrom) {
      notification.error({message: '请选择开始日期'});
      return false;
    }
    return true;
  };


  const onClickCreate = async () => {
    if (!validate()) {
      return;
    }

    const doCreate = async (key: IKey) => {
      if (alreadyExistKey(key)) {
        notification.warn({message: `diary ${IKeyMethods.asString(key)} already exist`});
        return;
      }

      const diary = newDiary(key);
      await apis.diaries.setDiary(diary);
      notification.success({message: `create new diary ${IKeyMethods.asString(key)} success`});
    };

    setOnCreateing(true);
    try {
      for (let date = dateFrom!.clone()!; date <= (dateTo ? dateTo : dateFrom!); date.add(1, 'days')) {
        const key = keyFromMoment(date);
        await doCreate(key);
      }
    } finally {
      swrDiaries.mutate();
      setOnCreateing(false);
    }
  };

  return <>
    <table>
      <tbody>
        <tr>
          <td style={{color: 'red'}}>*</td>
          <td>开始日期</td>
          <td>&nbsp;</td>
          <td><DatePicker onChange={(date: moment.Moment | null) => {
            if (date) {
              setDateFrom(date);
            }
          }} format={'YYYY/MM/DD'} disabledDate={disabledDateFrom} /></td>
        </tr>
        <tr>
          <td></td>
          <td>结束日期</td>
          <td>&nbsp;</td>
          <td>
            <DatePicker onChange={(date: moment.Moment | null) => {
              if (date) {
                setDateTo(date);
              }
            }} format={'YYYY/MM/DD'} disabledDate={disabledDateTo} />
          </td>
          <td>&nbsp;</td>
          <td style={{color: 'gray'}}>不填则仅创建 开始日期 单日的</td>
        </tr>
      </tbody>
      <tfoot>
      </tfoot>
    </table>
    <br />
    <Spin spinning={onCreating}>
      <Button type="primary" onClick={onClickCreate} >Create</Button>
    </Spin>
  </>;
};

type searcherName = 'main'

const Search: FC = () => {
  const [searcher, setSearcher] = useState<searcherName>('main');

  const [searchResultKeys, setSearchResultKeys] = useState<IKey[]>([]);
  const [chosenKey, chooseKey] = useState<IKey>();

  useEffect(() => {
    if (!chosenKey) {
      return;
    }
    for (const key of searchResultKeys) {
      if (IKeyMethods.equal(key, chosenKey)) {
        return;
      }
    }
    chooseKey(undefined);
  }, [searchResultKeys]); // note: even chooseKey would cause re-render


  const swrDiary = useSWR(
    chosenKey ? [chosenKey, '/diary/' + IKeyMethods.asString(chosenKey)] : null,
    apis.diaries.getDiary,
  );

  const [searching, setSearching] = useState(false);
  const doSearch = async (arg: object) => {
    setSearching(true);
    try {
      const keys = await apis.diaries.searchComponent(searcher, arg);
      setSearchResultKeys(keys ? keys : []);
    } catch (e: any) {
      // drop error
    }
    setSearching(false);
  };


  const Searcher: FC<{ searching: boolean, doSearch: (_: any) => void }> = (() => {
    switch (searcher) {
      case 'main':
        return MainSeacher;
    }
  })();

  return <Row>
    {/* 24: [1: space][6: seach][1: space][16: diary][1: space] */}
    <Col span={6} offset={1} >
      <Divider orientation="left" plain>
        component:
        <Select value={searcher} onChange={setSearcher} bordered={false}>
          <Select.Option value="main">main</Select.Option>
        </Select>
      </Divider>

      <Searcher searching={searching} doSearch={doSearch} />
      <Divider orientation="left" plain>
        {`found ${searchResultKeys.length} result${searchResultKeys.length > 1 ? 's' : ''}:`}
      </Divider>
      <Spin spinning={searching}>
        <ul style={{listStyleType: 'none', paddingLeft: 0}}>
          {searchResultKeys.map((key) => <li key={IKeyMethods.asNumber(key)} onClick={() => chooseKey(key)} >
            - <CheckableTag checked={chosenKey ? IKeyMethods.equal(chosenKey, key) : false}>{key.Year + '-' + key.Month + '-' + key.Day}</CheckableTag>
          </li>)}
        </ul>
      </Spin>
    </Col>
    <Col span={16} offset={1} >
      {swrDiary.data ? <Spin spinning={swrDiary.isValidating}><Components diary={swrDiary.data} mutate={swrDiary.mutate} options={{editable: false}} /></Spin> : <Skeleton />}
    </Col>
  </Row>;
};

interface mainSearchArg {
  Keywords: string[]
  MustContainAll: boolean,
  // todo[next]: support Mode
}

const MainSeacher: FC<{
  searching: boolean,
  doSearch: (_: mainSearchArg) => void,
}> = ({searching, doSearch}) => {
  return <Form onFinish={(values) => doSearch(values)} initialValues={{Keywords: []}}>
    <Form.List name="Keywords">
      {(fields, {add, remove}, {errors}) => (
        <>
          {fields.map((field, index) => (
            <Form.Item key={field.key}>
              <Form.Item
                {...field}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: 'Please input keyword name or delete this field.',
                  },
                ]}
                noStyle
              >
                <Input placeholder="keyword" style={{width: '80%'}} />
              </Form.Item>
              &nbsp;
              {fields.length > 1 ? <DeleteOutlined onClick={() => remove(field.name)} /> : null}
            </Form.Item>
          ))}
          <Form.Item>
            <Button type="dashed" onClick={() => add()} style={{width: '80%'}} icon={<PlusOutlined />} >Add Keyword</Button>
            <Form.ErrorList errors={errors} />
          </Form.Item>
        </>
      )}
    </Form.List>
    <Form.Item name="MustContainAll" label="MustContainAll" valuePropName="checked" >
      <Checkbox/>
    </Form.Item>
    <Form.Item>
      <Button type="primary" loading={searching} htmlType='submit' >Search</Button>
    </Form.Item>
  </Form>;
};
